import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #3f51b5, #5a55ae)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textAlign: 'center',
        p: 3,
      }}
    >
      <Stack spacing={3} alignItems="center">
        <ErrorOutlineIcon sx={{ fontSize: 100, color: '#fff' }} />
        <Typography variant="h3" fontWeight="bold">
          404 - Not Found
        </Typography>
        <Typography variant="subtitle1" sx={{ maxWidth: 400 }}>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: '#ffffff',
            color: '#3f51b5',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
            px: 4,
            py: 1.5,
            fontWeight: 'bold',
            borderRadius: 3,
            textTransform: 'none',
          }}
          onClick={() => navigate('/home')}
        >
          Go to Dashboard
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFound;
